"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Game_1 = require("./Game");
const KHContainer_1 = require("./KH/KHContainer");
const KHEventHandler_1 = require("./KH/KHEventHandler");
const KHHelperFunctions_1 = require("./KH/KHHelperFunctions");
const QUICK_ANIM_FADE = 16 * 2;
class SYTextContainer extends KHContainer_1.KHContainer {
    constructor(scene, rows, cols) {
        super(scene, 0, 0, Game_1.game.width, Game_1.game.height);
        this.rows = rows;
        this.cols = cols;
        this.emitter = new KHEventHandler_1.KHEventHandler();
        this.textHeight = 0;
        this.cachedText = '';
        this.texts = [];
        for (let y = 0; y < rows; y++) {
            const text = scene.add.dynamicBitmapText(4, 33 * (rows - 1 - y), 'font', '', 32).setTint(0x0);
            this.texts.push(text);
            this.add(text);
        }
        this.textHeight = 0;
    }
    setText(text) {
        this.cachedText = text;
        const modText = text + 'o';
        let thisHeight = 0;
        for (let i = 0; i < this.texts.length; i++) {
            const raw = modText.slice(i * this.cols, (i + 1) * this.cols);
            if (raw.length > 0)
                thisHeight = i;
            let sliced = raw.padEnd(this.cols, ' ');
            if (i % 2 == 1)
                sliced = [...sliced].reverse().join('');
            this.texts[i].text = sliced;
        }
        if (thisHeight !== this.textHeight) {
            this.textHeight = thisHeight;
            this.emitter.emitEvent('heightChanged', { height: this.textHeight });
        }
        this.emitter.emitEvent('updateText', { text });
    }
    startFade(duration, fadeCallback, fadeIndex = 0) {
        this.hideLastCharacter(duration, (empty) => {
            fadeCallback === null || fadeCallback === void 0 ? void 0 : fadeCallback(empty, fadeIndex);
        }, 0);
    }
    cancelFade() {
        var _a;
        (_a = this.activeFade) === null || _a === void 0 ? void 0 : _a.setDisplayCallback(undefined);
        this.activeFade = undefined;
    }
    modifiedIndexForRow(row, index) {
        if (row % 2 !== 1)
            return index;
        return this.cols - 1 - index;
    }
    doLoss() {
        this.emitter.emitEvent('interactionAllowed', { allowed: false });
        this.doLossInternal(this.cachedText.length);
    }
    hideLastCharacter(duration, callback, overage) {
        if (this.cachedText.length === 0) {
            callback(true, 0);
            return;
        }
        const idx = this.cachedText.length - 1;
        if (idx >= 0) {
            const rowNum = Math.floor(idx / this.cols);
            const indexInRow = this.modifiedIndexForRow(rowNum, Math.floor(idx % this.cols));
            const currRow = this.texts[rowNum];
            if (!currRow) {
                console.warn('row num out of bounds', rowNum);
                callback(true, 0);
                return;
            }
            if (duration - overage <= 0) {
                this.setText(this.cachedText.slice(0, -1));
                callback(false, overage - duration);
                return;
            }
            const startTime = this.scene.time.now;
            const endTime = startTime + duration;
            this.activeFade = currRow;
            currRow.setDisplayCallback((data) => {
                const percent = (0, KHHelperFunctions_1.percentClamped)(startTime, endTime, this.scene.time.now);
                const color = data.index === indexInRow ? (0, KHHelperFunctions_1.lerpColor)(0, 0xFFFFFF, percent) : 0x0;
                data.tint.bottomLeft = color;
                data.tint.bottomRight = color;
                data.tint.topLeft = color;
                data.tint.topRight = color;
                if (data.index === indexInRow && percent >= 1) {
                    this.setText(this.cachedText.slice(0, -1));
                    currRow.setDisplayCallback(undefined);
                    callback(false, this.scene.time.now - endTime);
                    return data;
                }
                return data;
            });
        }
    }
    doLossInternal(startingLength, overage = 0) {
        const percentOfMax = (0, KHHelperFunctions_1.percentClamped)(100, 900, startingLength);
        const maxDuration = (0, KHHelperFunctions_1.lerp)(1000, 4500, percentOfMax);
        const duration = Math.min(QUICK_ANIM_FADE, maxDuration / startingLength);
        this.hideLastCharacter(duration, (empty, overage) => {
            if (this.cachedText.length === 0) {
                this.emitter.emitEvent('interactionAllowed', { allowed: true });
            }
            else {
                this.doLossInternal(startingLength, overage);
            }
        }, overage);
    }
}
exports.default = SYTextContainer;
